import './styles.scss'

import {Button, Card, Col, Container, FormGroup, Input, Nav, NavItem, Row} from 'reactstrap'
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {NavLink as NavLinkStrap} from 'reactstrap'
import {Registration} from './components/Registration'
import {useIntl} from 'react-intl'

export function AuthPage() {
  const intl = useIntl()

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div className='hero-wrapper w-100 bg-composed-wrapper bg-midnight-bloom'>
      <div className='flex-grow-1 w-100 d-flex align-items-center' style={{ height: '90vh' }}>
        <div className='bg-composed-wrapper--image opacity-6' />
        <div className='bg-composed-wrapper--bg bg-second opacity-7' />
        <div className='bg-composed-wrapper--content p-3 p-md-5'>
          <Container className='container-auth '>
            <Switch>
              <Route path='/auth/login' component={Login} />
              <Route path='/auth/registration' component={Registration} />
              <Route path='/auth/forgot-password' component={ForgotPassword} />
              <Redirect from='/auth' exact={true} to='/auth/login' />
              <Redirect to='/auth/login' />
            </Switch>
          </Container>
        </div>
      </div>
      <div className='hero-footer w-100 pb-4'>
        <Container>
          <div className='py-3 d-block d-lg-flex font-size-xs justify-content-between'>
            <div className='text-center d-block mb-3 mb-md-0 text-white'>
              Copyright &copy; {new Date().getFullYear() } - {process.env.REACT_APP_NAME}
            </div>
            <Nav className='nav-transparent justify-content-center'>
              <NavItem>
                <NavLinkStrap
                  className='text-white-50'
                  href='#/'
                  onClick={(e) => e.preventDefault()}
                >
                  {intl.formatMessage({id: 'PRIVACY_POLICY'})}
                </NavLinkStrap>
              </NavItem>
              <NavItem>
                <NavLinkStrap
                  className='text-white-50'
                  href='#/'
                  onClick={(e) => e.preventDefault()}
                >
                  {intl.formatMessage({id: 'TERMS_OF_SERVICE'})}
                </NavLinkStrap>
              </NavItem>
            </Nav>
          </div>
        </Container>
      </div>
    </div>
  )
}
